import React, { memo, useContext } from "react";

import queryString from "query-string";

import { ScrollOnFocusContext } from "components/Form/FormikControls/focus";

import {
  WeighBridgeSaleContextProvider,
  WeighBridgeSaleStateContext,
} from "./WeighBridgeSaleContext";
import WeighbridgeSaleView from "./WeighBridgeSaleView";

function WeighBridgeSaleStateConsumer() {
  const { saleMode, initialSaleLotId, weightCaptureMode } = useContext(
    WeighBridgeSaleStateContext,
  );
  return (
    <WeighbridgeSaleView
      initialSaleLotId={initialSaleLotId}
      saleMode={saleMode}
      weightCaptureMode={weightCaptureMode}
    />
  );
}

function WeighbridgeSaleViewRouteComponent() {
  const { saleLotId } = queryString.parse(window.location.search);

  return (
    <ScrollOnFocusContext.Provider value={false}>
      <WeighBridgeSaleContextProvider initialSaleLotId={saleLotId}>
        <WeighBridgeSaleStateConsumer />
      </WeighBridgeSaleContextProvider>
    </ScrollOnFocusContext.Provider>
  );
}

export default memo(WeighbridgeSaleViewRouteComponent, () => true);
